<template>
  <div :id="`logged-email-${loggedEmail.id}`">
    <bookmark-modal modelType="LoggedEmail" :modelId="loggedEmail.id"
      :currentValue="loggedEmail.bookmark"></bookmark-modal>

    <div class="card shadow-none">
      <div class="card-body" :class="{'pb-0': collapsed}">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
                            <span class="avatar-title rounded bg-soft-primary text-primary font-size-16">
                              {{ loggedEmail.agent ? loggedEmail.agent.name.charAt(0) : '?' }}
                            </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <span class="name">{{ loggedEmail.agent ? loggedEmail.agent.name : 'Unknown' }}</span> logged an email
            </div>
            <small>
              <i>{{ displayTimestamp(loggedEmail.created_at) }}</i>
            </small>
          </div>
          <div class="tl-actions" v-if="!disableActions">
            <a href="#" class="btn btn-link text-muted" @click.prevent="toggleCollapsed">
              <i class="fa" :class="{'fa-chevron-down': collapsed, 'fa-chevron-up': !collapsed}"></i>
            </a>

            <a href="#" class="btn btn-link text-muted pl-1 pr-1" @click.prevent="openBookmarkModal">
              <i class="fa fa-heart" :class="{
                'text-danger': loggedEmail.bookmark
              }"></i>
            </a>

            <b-dropdown variant="white" right toggle-class="text-muted pt-0 pr-0 pb-0">
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="requestDelete" variant="danger">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">From:</b>
            <span class="mr-2">{{ loggedEmail.sender }}</span>
          </div>
        </div>
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">To:</b>
            <span class="mr-2" v-for="(email, i) in recipients" :key="`logged-email-receipient-${loggedEmail.id}-${i}`">{{ email }}</span>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <!-- Main email content -->
            <div class="main-email-content-box mb-3">
              <div v-html="mainEmailContent"></div>
            </div>
            
            <!-- Thread collapse button -->
            <div v-if="hasQuotedContent && !collapsed" class="mt-2">
              <a href="#" 
                 class="btn btn-sm btn-itg" 
                 @click.prevent="toggleThreadCollapsed"
                 :aria-expanded="!threadCollapsed"
                 :aria-label="`${threadCollapsed ? 'Show' : 'Hide'} email thread with ${threadCountText}`"
                 role="button"
                 tabindex="0">
                <i class="fa" :class="{'fa-chevron-down': threadCollapsed, 'fa-chevron-up': !threadCollapsed}"></i>
                {{ threadCollapsed ? 'Show' : 'Hide' }} email thread
                <span v-if="threadCollapsed && threadSummary" class="text-muted ml-2">({{ threadSummary }})</span>
                <span v-if="threadCount > 0" class="badge badge-light ml-2">{{ threadCountText }}</span>
              </a>
            </div>
            
            <!-- Quoted content -->
            <div v-if="hasQuotedContent && !collapsed && !threadCollapsed" class="mt-3 quoted-content">
              <div class="border-left pl-3" style="border-left: 3px solid #dee2e6 !important;">
                <div class="quoted-header mb-2 d-flex justify-content-between align-items-center">
                  <small class="text-muted">
                    <i class="fa fa-reply"></i> Previous messages in thread
                    <span v-if="threadCount > 0" class="ml-1">({{ threadCountText }})</span>
                  </small>
                  <div>
                    <button v-if="individualMessages.length > 1" 
                            class="btn btn-sm btn-link text-muted p-0 mr-2" 
                            @click="toggleAllMessages"
                            :title="hasCollapsedMessages ? 'Expand all messages' : 'Collapse all messages'"
                            aria-label="Toggle all messages">
                      <i class="fa" :class="hasCollapsedMessages ? 'fa-expand' : 'fa-compress'"></i>
                    </button>
                    <button class="btn btn-sm btn-link text-muted p-0" 
                            @click="threadCollapsed = true"
                            title="Hide thread"
                            aria-label="Hide email thread">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                
                <!-- Individual messages -->
                <div v-if="individualMessages.length > 0" class="individual-messages">
                  <div v-for="message in individualMessages" :key="message.id" class="message-item mb-3">
                    <div class="message-content" :style="{ marginLeft: `${message.depth * 20}px` }">
                      <!-- <div v-if="Object.keys(extractMessageMetadata(message.content)).length > 0" class="message-meta mb-2 p-2 rounded bg-light border">
                        <div v-if="extractMessageMetadata(message.content).from"><b>From:</b> {{ extractMessageMetadata(message.content).from }}</div>
                        <div v-if="extractMessageMetadata(message.content).sent"><b>Sent:</b> {{ extractMessageMetadata(message.content).sent }}</div>
                        <div v-if="extractMessageMetadata(message.content).to"><b>To:</b> {{ extractMessageMetadata(message.content).to }}</div>
                        <div v-if="extractMessageMetadata(message.content).cc"><b>Cc:</b> {{ extractMessageMetadata(message.content).cc }}</div>
                        <div v-if="extractMessageMetadata(message.content).subject"><b>Subject:</b> {{ extractMessageMetadata(message.content).subject }}</div>
                      </div> -->
                      <div v-html="message.content"></div>
                    </div>
                  </div>
                </div>
                
                <!-- Fallback for content that couldn't be parsed into individual messages -->
                <div v-else v-html="quotedEmailContent"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- / tl-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Dates from "../../../../../mixins/Dates";
import Forms from "../../../../../mixins/Forms";
import axios from "axios";
import eventBus from "../../../../../event-bus";
import BookmarkModal from './BookmarkModal.vue';

export default {
  props: ['loggedEmail', 'disableActions'],
  name: "LoggedEmail",

  data() {
    return {
      collapsed: false,
      threadCollapsed: true, // Default to collapsed thread
      isLoading: false,
      showThreadCount: false,
      collapsedMessages: new Set() // Track which individual messages are collapsed
    }
  },

  created() {
    eventBus.$on('collapse-all', () => {
      this.collapsed = true;
    });
    eventBus.$on('expand-all', () => {
      this.collapsed = false;
    });
  },

  updated() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  beforeDestroy() {
    eventBus.$off('collapse-all');
    eventBus.$off('expand-all');
  },

  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    }),

    recipients() {
      // return JSON.parse(this.loggedEmail.recipients)
      return this.loggedEmail.recipients;
    },

    hasQuotedContent() {
      if (!this.loggedEmail.body) return false;
      
      // Check for common email thread indicators
      const quotedIndicators = [
        '<blockquote',
        'On ',
        'From:',
        'Sent:',
        'To:',
        'Subject:',
        'Re:',
        'Fwd:',
        '> ',
        '&gt; ',
        '-----Original Message-----',
        'From: ',
        'Sent: ',
        'To: ',
        'Subject: ',
        'Cc: ',
        'Bcc: '
      ];
      
      return quotedIndicators.some(indicator => 
        this.loggedEmail.body.includes(indicator)
      );
    },

    mainEmailContent() {
      if (!this.hasQuotedContent) {
        return this.loggedEmail.body;
      }

      // Try to split on common email thread boundaries
      const body = this.loggedEmail.body;
      
      // Look for common email thread separators in order of preference
      const separators = [
        /<hr[^>]*>/i,
        /<div[^>]*>.*?From:.*?<\/div>/i,
        /<blockquote[^>]*>/i,
        /-----Original Message-----/i,
        /On \d{1,2} [A-Za-z]+ \d{4}/,
        /From: [^<]+<[^>]+>/,
        /Sent: \d{1,2} [A-Za-z]+ \d{4}/,
        /To: [^<]+<[^>]+>/,
        /Subject: [^<]+/,
        /Cc: [^<]+<[^>]+>/,
        /Bcc: [^<]+<[^>]+>/
      ];

      for (const separator of separators) {
        const match = body.match(separator);
        if (match) {
          const index = body.indexOf(match[0]);
          if (index > 0) {
            return body.substring(0, index).trim();
          }
        }
      }

      // If no clear separator found, try to find the first quoted line
      const lines = body.split('\n');
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.startsWith('>') || line.startsWith('&gt;') || 
            line.includes('On ') || line.includes('From:') || 
            line.includes('Sent:') || line.includes('To:') ||
            line.includes('Subject:') || line.includes('Cc:') ||
            line.includes('Bcc:')) {
          return lines.slice(0, i).join('\n').trim();
        }
      }

      // Fallback: return first 500 characters if body is long
      if (body.length > 500) {
        return body.substring(0, 500) + '...';
      }

      return body;
    },

    quotedEmailContent() {
      if (!this.hasQuotedContent) {
        return '';
      }

      const body = this.loggedEmail.body;
      const mainContent = this.mainEmailContent;
      
      // If main content is the same as body, no quoted content
      if (mainContent === body) {
        return '';
      }

      // Return the part after the main content
      const mainIndex = body.indexOf(mainContent);
      if (mainIndex !== -1) {
        return body.substring(mainIndex + mainContent.length).trim();
      }

      return body;
    },

    threadSummary() {
      if (!this.hasQuotedContent || this.threadCollapsed) {
        return '';
      }

      const quoted = this.quotedEmailContent;
      if (!quoted) return '';

      // Try to extract a summary from the quoted content
      const lines = quoted.split('\n').slice(0, 3);
      const summary = lines.join(' ').substring(0, 100);
      return summary + (summary.length >= 100 ? '...' : '');
    },

    threadCount() {
      // Use the number of parsed messages for accuracy
      return Math.max(1, this.individualMessages.length);
    },

    threadCountText() {
      const count = this.threadCount;
      if (count === 0) return '';
      if (count === 1) return '1 previous message';
      return `${count} previous messages`;
    },

    // Parse individual email messages from the quoted content
    individualMessages() {
      if (!this.hasQuotedContent || !this.quotedEmailContent) {
        return [];
      }

      const messages = [];
      const content = this.quotedEmailContent;
      
      // More comprehensive email separators in order of preference
      const separators = [
        /On\s+\d{1,2}\s+[A-Za-z]+\s+\d{4},?.*wrote:/g, // Capital 'O' only
        /<hr[^>]*>/gi,
        /-----Original Message-----/gi,
        /On \d{1,2} [A-Za-z]+ \d{4}/gi,
        /From: [^<]+<[^>]+>/gi,
        /Sent: \d{1,2} [A-Za-z]+ \d{4}/gi,
        /To: [^<]+<[^>]+>/gi,
        /Subject: [^<]+/gi,
        /Cc: [^<]+<[^>]+>/gi,
        /Bcc: [^<]+<[^>]+>/gi
      ];

      let lastIndex = 0;
      let messageIndex = 0;

      for (const separator of separators) {
        const matches = content.matchAll(separator);
        for (const match of matches) {
          if (match.index > lastIndex) {
            const messageContent = content.substring(lastIndex, match.index).trim();
            if (messageContent) {
              // Calculate depth based on multiple indentation patterns
              const depth = this.calculateMessageDepth(messageContent);
              
              messages.push({
                id: `message-${messageIndex}`,
                content: messageContent,
                separator: match[0],
                index: messageIndex,
                depth: depth
              });
              messageIndex++;
            }
            lastIndex = match.index;
          }
        }
      }

      // Add the last message if there's content after the last separator
      const remainingContent = content.substring(lastIndex).trim();
      if (remainingContent) {
        const depth = this.calculateMessageDepth(remainingContent);
        
        messages.push({
          id: `message-${messageIndex}`,
          content: remainingContent,
          separator: '',
          index: messageIndex,
          depth: depth
        });
      }

      return messages;
    },

    // Get visible messages (not collapsed)
    visibleMessages() {
      return this.individualMessages.filter(msg => !this.collapsedMessages.has(msg.id));
    },

    // Check if any messages are collapsed
    hasCollapsedMessages() {
      return this.collapsedMessages.size > 0;
    }
  },

  components: {BookmarkModal},

  mixins: [Dates, Forms],

  methods: {
    ...mapActions('ticketViewer', {
      reloadTicket: 'reloadTicket'
    }),

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    toggleThreadCollapsed() {
      this.threadCollapsed = !this.threadCollapsed;
    },

    // Toggle individual message collapse
    toggleMessage(messageId) {
      if (this.collapsedMessages.has(messageId)) {
        this.collapsedMessages.delete(messageId);
      } else {
        this.collapsedMessages.add(messageId);
      }
    },

    // Toggle all messages collapse/expand
    toggleAllMessages() {
      if (this.hasCollapsedMessages) {
        // Expand all
        this.collapsedMessages.clear();
      } else {
        // Collapse all
        this.individualMessages.forEach(msg => this.collapsedMessages.add(msg.id));
      }
    },

    // Enhanced method to clean up email content
    cleanEmailContent(content) {
      if (!content) return '';
      
      // Remove excessive whitespace and normalize line breaks
      return content
        .replace(/\n\s*\n\s*\n/g, '\n\n') // Remove multiple consecutive empty lines
        .replace(/\s+$/gm, '') // Remove trailing whitespace from lines
        .trim();
    },

    // Method to extract email metadata from quoted content
    extractEmailMetadata(quotedContent) {
      const metadata = {};
      
      // Extract common email headers
      const fromMatch = quotedContent.match(/From:\s*([^<\n]+)/i);
      if (fromMatch) metadata.from = fromMatch[1].trim();
      
      const toMatch = quotedContent.match(/To:\s*([^<\n]+)/i);
      if (toMatch) metadata.to = toMatch[1].trim();
      
      const subjectMatch = quotedContent.match(/Subject:\s*([^\n]+)/i);
      if (subjectMatch) metadata.subject = subjectMatch[1].trim();
      
      const dateMatch = quotedContent.match(/Sent:\s*([^\n]+)/i);
      if (dateMatch) metadata.date = dateMatch[1].trim();
      
      return metadata;
    },

    openBookmarkModal() {
      this.$bvModal.show("bookmark-modal-LoggedEmail-" + this.loggedEmail.id);
    },

    requestDelete() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this note?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete"
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.delete();
        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios.delete(API_BASE + '/tickets/' + this.ticket.id + '/logged-emails/' + this.loggedEmail.id).then(r => {
        vm.isSaving = false;
        vm.reloadTicket();
        this.$notify.success({
          title: 'Success!',
          message: 'Logged email deleted successfully'
        });
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    },

    // Helper method to calculate message depth
    calculateMessageDepth(content) {
      let depth = 0;
      const lines = content.split('\n');
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line.startsWith('>') || line.startsWith('&gt;')) {
          depth++;
        } else {
          break; // Stop counting if a non-indented line is found
        }
      }
      return Math.min(depth, 5); // Limit depth to 5
    },

    // Helper to strip HTML tags for header extraction
    stripHtmlTags(str) {
      if (!str) return '';
      return str.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    },

    // Extract metadata from individual message
    extractMessageMetadata(content) {
      const metadata = {};
      // Strip HTML tags for header extraction
      const clean = this.stripHtmlTags(content);
      // Extract sender
      const fromMatch = clean.match(/From:\s*([^\n]+)/i);
      if (fromMatch) metadata.from = fromMatch[1].trim();
      // Extract date
      const sentMatch = clean.match(/Sent:\s*([^\n]+)/i);
      if (sentMatch) metadata.sent = sentMatch[1].trim();
      // Extract subject
      const subjectMatch = clean.match(/Subject:\s*([^\n]+)/i);
      if (subjectMatch) metadata.subject = subjectMatch[1].trim();
      // Extract recipient
      const toMatch = clean.match(/To:\s*([^\n]+)/i);
      if (toMatch) metadata.to = toMatch[1].trim();
      // Extract cc
      const ccMatch = clean.match(/Cc:\s*([^\n]+)/i);
      if (ccMatch) metadata.cc = ccMatch[1].trim();
      return metadata;
    }
  }
}
</script>

<style scoped>
.card {
  background-image: linear-gradient(#fef1e1, #fef1e1);
}

.quoted-content {
  opacity: 0.8;
  font-size: 0.9em;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  transition: all 0.3s ease;
}

.quoted-header {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 5px;
}

.quoted-content .quoted-content {
  opacity: 0.6;
  font-size: 0.85em;
}

/* Focus styles for accessibility */
.btn:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Badge styling */
.badge-light {
  background-color: #f8f9fa;
  color: #6c757d;
  font-size: 0.75em;
}

/* Hover effects */
.btn-outline-secondary:hover {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

/* Smooth transitions */
.btn {
  transition: all 0.2s ease;
}

/* Loading state */
.isLoading {
  opacity: 0.6;
  pointer-events: none;
}

/* Individual message styling */
.individual-messages {
  margin-top: 10px;
}

.message-item {
  border-left: 2px solid #e9ecef;
  padding-left: 15px;
  margin-bottom: 15px;
  position: relative;
  transition: all 0.2s ease;
}

/* Remove the hover border color effect from .message-item */
.message-item:hover {
  border-left-color: #e9ecef;
}

.message-item:before {
  content: '';
  position: absolute;
  left: -2px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #007bff, #6c757d);
}

.message-header {
  background-color: rgba(0, 123, 255, 0.05);
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 123, 255, 0.1);
}

.message-content {
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.message-content:hover {
  background-color: rgba(255, 255, 255, 0.8);
  /* border-color: #007bff; */
}

.message-collapsed {
  padding: 8px 12px;
  background-color: rgba(108, 117, 125, 0.1);
  border-radius: 4px;
  border: 1px dashed #dee2e6;
  font-style: italic;
}

/* Nested message styling */
.message-content .message-item {
  margin-top: 10px;
  border-left-color: #6c757d;
}

.message-content .message-item:before {
  background: linear-gradient(to bottom, #6c757d, #adb5bd);
}

/* Message metadata styling */
.text-info {
  color: #17a2b8 !important;
}

/* Improved spacing for message headers */
.message-header .d-flex {
  flex-wrap: wrap;
  gap: 8px;
}

.main-email-content-box {
  background: hsla(0,0%,100%,.5);
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 10px;
  /* box-shadow: 0 1px 2px rgba(0,0,0,0.03); */
}
</style>
